<template>
    <div class="userInfo" v-if="showView">
        <van-nav-bar
                title="实名补登记"
                left-arrow
                :fixed='true'
                @click-left="onClickBack"
            />
        <div v-if="currentStep == 1" class="inputView">
            <div class="choicePage-logo">
                <img :src="logoUrl" width="100%" height="100%"/>
            </div>
            <van-cell-group>
                <van-field
                    label="实名号码:"
                    placeholder="请输入需要二次实名号码"
                    left-icon="phone-o"
                    type="number"
                    required
                    maxlength=11
                    v-model="userInfo.phonenum"
                />
            </van-cell-group>
            <div class="contract">
                <input type="checkbox" v-model="userInfo.readContract" />
                <span @click="showContract()" >我已阅读并同意《民生通讯入网协议》</span>
            </div>
            <div class="submitInfo">
                <van-button type="primary" size="large" @click="checkPhone()" loading-text='正在校验中...'>下一步</van-button>
            </div>
        </div>
        <div v-if="currentStep == 2">
            <div class="dataView">
                <van-panel title="证件正面照+手机卡" desc="上传证件材料(上传的手机卡ICCID信息需清晰可见)">
                    <PictureCamera class="picInfo-cell" :picWidth.sync='picWidth' :picHeight.sync='picHeight' :picOver.sync='picOver[0].imgPath' :resultImage.sync='userInfo.picNameZ' :desc.sync='picOver[0].desc' :imageInfoObj.sync='imageZInfoObj' :isAnalyze.sync='isAnalyzeZ'  :uploadImagePath.sync='uploadImagePath' :readImagePath.sync='readImagePath' />
                </van-panel>
                <van-cell-group>
                    <van-field
                        placeholder="可上传证件照正面自动识别"
                        label="姓名:"
                        left-icon="contact"
                        required
                        v-model="userInfo.custName"
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="性别:"
                        left-icon="friends-o"
                        required
                        v-model="userInfo.sex"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="民族:"
                        left-icon="wap-home-o"
                        required
                        v-model="userInfo.nation"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="出生日期:"
                        left-icon="birthday-cake-o"
                        required
                        v-model="userInfo.birthday"
                        readonly
                    />
                    <van-field
                        placeholder="上传证件照正面自动识别"
                        label="身份证号:"
                        left-icon="idcard"
                        required
                        v-model="userInfo.psptId"
                        readonly
                    />
                    <van-field
                        placeholder="可上传证件照正面自动识别"
                        label="证件地址:"
                        left-icon="shrink"
                        required
                        type="textarea"
                        rows="2"
                        v-model="userInfo.psptLocation"
                    />
                </van-cell-group>
            </div>
            <div class="submitInfo2">
                <van-button :disabled='showNextBtn!=3' type="primary" size="large" @click="nextClick(3)">下一步</van-button>
            </div>
        </div>
        <div v-if="currentStep == 3">
            <van-panel title="证件反面照+手机卡" desc="上传证件材料（身份证照片上的信息必须清晰可见）">
                <PictureCamera class="picInfo-cell" :picWidth.sync='picWidth' :picHeight.sync='picHeight' :picOver.sync='picOver[1].imgPath' :resultImage.sync='userInfo.picNameF' :desc.sync='picOver[1].desc' :imageInfoObj.sync='imageFInfoObj' :isAnalyze.sync='isAnalyzeF'  :uploadImagePath.sync='uploadImagePath' :readImagePath.sync='readImagePath' />
            </van-panel>
            <van-cell-group>
                <van-field
                    placeholder="可上传证件照正面自动识别"
                    label="证件签发组织:"
                    left-icon="cluster-o"
                    required
                    readonly
                    v-model="userInfo.penOrg"
                />
                <van-field
                    placeholder="可上传证件照正面自动识别"
                    label="证件发放日期:"
                    left-icon="paid"
                    required
                    readonly
                    v-model="userInfo.penStartTime"
                />
                <van-field
                    placeholder="可上传证件照正面自动识别"
                    label="证件到期日期:"
                    left-icon="pending-payment"
                    required
                    readonly
                    v-model="userInfo.penEndTime"
                />
            </van-cell-group>
            <div class="submitInfo2">
                <van-button :disabled='showNextBtn!=4' type="primary" size="large" @click="nextClick(4)">下一步</van-button>
            </div>
        </div>
        <div v-if="currentStep == 4">
            <van-panel title="个人免冠照" desc="上传的需为本人个人照">
                <PictureCamera class="picInfo-cell" :picWidth.sync='picWidth' :picHeight.sync='picHeight' :picOver.sync='picOver[2].imgPath' :resultImage.sync='userInfo.picNameT' :desc.sync='picOver[2].desc' :imageInfoObj.sync='imageTInfoObj'  :uploadImagePath.sync='uploadImagePath' :readImagePath.sync='readImagePath' />
            </van-panel>
            <van-cell-group>
                <van-field
                    placeholder="请输入联系号码"
                    label="联系号码:"
                    left-icon="phone-o"
                    style="color:red;"
                    required
                    error
                    maxlength=11
                    type="number"
                    v-model="userInfo.contractPhone"
                />
            </van-cell-group>
            
            <div class="submitInfo2">
                <van-button :disabled='userInfo.picNameT == null || userInfo.contractPhone == "" || userInfo.contractPhone.length != 11'  type="primary" size="large" @click="submitInfo()" loading-text='正在提交...'>提交信息</van-button>
            </div>
        </div>
        <div v-if="currentStep == 5" class="submitResult">
            <div class="submitResult-img">
                <img src="../../assets/microCard/success.png"/>
            </div>
            <div class="submitResult-text">
                <div class="submitResult-text-main">
                    <div>信息提交成功,等待审核</div>
                    <div class="submitResult-text-main-desc">如有疑问,请联系客服!感谢您的支持!</div>
                </div>
            </div>
        </div>
        <van-popup class="loadingPopup" v-model="loadingObj.showLoading" style="background-color:#4C4C4C;" :lazy-render=false :close-on-click-overlay=false >
            <van-loading size="24px" vertical>{{loadingObj.loadingText}}</van-loading>
        </van-popup>
    </div>
</template>

<script>
    import PictureCamera from '@/components/PictureCamera';
    import logo from '@/assets/mstxLogo.png'
    import zmOver from '@/assets/z.png';
    import fmOver from '@/assets/f.png';
    import tmOver from '@/assets/t.png';
    import {isWeiXin} from '../../common/functionUtil';
    import wxScan from '../../common/wxScan'

    export default {
        name: "secondRealName",
        mixins: [wxScan],
        components: {
            PictureCamera
        },
        data(){
            return {
                showView:false,
                showNextBtn:'0',
                logoUrl:logo,
                currentStep:'1',
                picWidth:'280px',
                picHeight:'200px',
                uploadImagePath:this.$api.uploadBossFileBaseUrl,
                readImagePath:this.$api.readBossImagePath,
                picOver:[
                    {desc:'Z',imgPath:zmOver},
                    {desc:'F',imgPath:fmOver},
                    {desc:'T',imgPath:tmOver}
                ],
                imageZInfoObj:{},
                imageFInfoObj:{},
                imageTInfoObj:{},
                isAnalyzeZ:true,//是否解析证件照
                isAnalyzeF:true,//是否解析证件照
                loadingObj:{
                    showLoading:false,
                    loadingText:''
                },
                picNameZ:null,
                picNameF:null,
                picNameT:null,
                userInfo:{
                    readContract:false,
                    userInfo:'',
                    custName:'',
                    psptId:'',
                    sex:'',
                    nation:'',
                    psptLocation:'',
                    contractPhone:'',
                    penOrg:'',
                    penStartTime:'',
                    penEndTime:'',
                    picNameZ:null,
                    picNameF:null,
                    picNameT:null
                }
            }
        },
        watch:{
            imageZInfoObj(val){
                if(val !=''){
                    this.userInfo.psptId = val.IDCard;
                    this.userInfo.custName = val.name;
                    this.userInfo.psptLocation =val.address;
                    this.userInfo.nation =val.nation;
                    this.userInfo.sex =val.sex;
                    this.userInfo.birthday =val.birthday;
                    this.picNameZ =val.imagePath;
                    this.showNextBtn = 3;
                }
            },
            imageFInfoObj(val){
                if(val !=''){
                    this.userInfo.penOrg = val.penOrg;
                    this.userInfo.penStartTime = val.penStartTime;
                    this.userInfo.penEndTime =val.penEndTime;
                    this.picNameF =val.imagePath;
                    this.showNextBtn = 4;
                }
            },
            imageTInfoObj(val){
                if(val !=''){
                    this.picNameT =val.imagePath;
                    this.showNextBtn = 5;
                }
            }
        },
        created(){
                this.showView = true;
            // if(!this.isWeiXin()){
            //     this.$toast({
            //         message: "请在微信手机端中打开该链接",
            //         icon: 'fail'
            //     });
            //     this.showView = false;
            //     return;
            // }else{
            //     this.showView = true;
            // }
            // this.$dialog.alert({
            //     message: '由于系统升级，2021年4月9日18点至4月10日8点无法办理任何业务。给您造成的不便，敬请谅解。',
            // });
            // this.wxPenSign('https://www.ms170.cn/choiceNumber/secondRealName',true);
        },
        methods: {
            isWeiXin,
            onClickBack() {
                this.$router.back(-1);//返回上一层
            },
            showContract(){
                window.location.href = "https://www.ms170.cn/choiceNumber/networkAccessProtocol";
            },
            nextClick(index){
                if(index == 3){
                    if(this.userInfo.picNameZ == ''
                 || this.userInfo.picNameZ == null){
                        this.$toast({
                            message: '请上传身份证正面',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.psptId == ''){
                        this.$toast({
                            message: '证件号码不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.custName == ''){
                        this.$toast({
                            message: '用户名不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.sex == ''){
                        this.$toast({
                            message: '性别不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.nation == ''){
                        this.$toast({
                            message: '民族不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.birthday == ''){
                        this.$toast({
                            message: '出生日期不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.psptLocation == ''){
                        this.$toast({
                            message: '证件地址不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                    //校验证件
                    this.checkPspstId();
                    return;
                }else if(index ==4){
                    if(this.userInfo.picNameZ == ''
                 || this.userInfo.picNameZ == null){
                        this.$toast({
                            message: '请上传身份证反面',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.penOrg == ''){
                        this.$toast({
                            message: '证件发放组织机构不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.penStartTime == ''){
                        this.$toast({
                            message: '证件签发日期不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                    if(this.userInfo.penEndTime == ''){
                        this.$toast({
                            message: '证件到期日期不能为空',
                            icon: 'fail'
                        });
                        return;
                    }
                }
                this.currentStep = index;
            },
            checkPhone: function () {
                if (this.userInfo.phonenum == null || this.userInfo.phonenum.length != 11) {
                    this.$toast({
                        message: '请输入有效的民生号码',
                        icon: 'fail'
                    });
                    return;
                }
                if(!this.userInfo.readContract){
                    this.$toast({
                        message: '请先阅读《民生通讯用户入网协议》',
                        icon: 'fail'
                    });
                    return;
                }
                var data = {
                    'service': 'user.networkRealnameInfo',
                    'phoneLevel':"5",
                    'phonenum': this.userInfo.phonenum,
                }
                this.loadingObj.loadingText ="信息校验中";
                this.loadingObj.showLoading = true;
                this.$api.post('/mstx/pr/gateway.do', data, () => {
                    this.loadingObj.showLoading = false;
                    this.nextClick(2);
                },(res)=>{
                    this.loadingObj.showLoading = false;
                    this.$toast.fail(res.errorMsg);
                });
            },
            //校验证件
            checkPspstId(){
                 var data = {
                    'service': 'user.realNameCheckUserInfo',
                    'phoneLevel':"5",
                    'phonenum': this.userInfo.phonenum,
                    'psptId': this.userInfo.psptId,
                    'custName': this.userInfo.custName,

                }
                this.loadingObj.loadingText ="信息校验中";
                this.loadingObj.showLoading = true;
                this.$api.post('/mstx/pr/gateway.do', data, () => {
                    this.loadingObj.showLoading = false;
                    this.currentStep=3;
                },(res)=>{
                    this.loadingObj.showLoading = false;
                    this.$toast.fail(res.errorMsg);
                });
            },
            submitInfo(){
                //数据校验
                if(this.userInfo.contractPhone == ''){
                    this.$toast({
                        message: '联系号码不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.contractPhone.length != 11){
                    this.$toast({
                        message: '联系号码格式错误',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.psptId == ''){
                    this.$toast({
                        message: '证件号码不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.custName == ''){
                    this.$toast({
                        message: '用户名不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.sex == ''){
                    this.$toast({
                        message: '性别不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.nation == ''){
                    this.$toast({
                        message: '民族不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.birthday == ''){
                    this.$toast({
                        message: '出生日期不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.psptLocation == ''){
                    this.$toast({
                        message: '证件地址不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.penOrg == ''){
                    this.$toast({
                        message: '证件发放组织机构不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.penStartTime == ''){
                    this.$toast({
                        message: '证件签发日期不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.penEndTime == ''){
                    this.$toast({
                        message: '证件到期日期不能为空',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.picNameZ == '' || this.userInfo.picNameZ == null){
                    this.$toast({
                        message: '请先上传证件照正面照片',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.picNameF == '' || this.userInfo.picNameF == null){
                    this.$toast({
                        message: '请先上传证件照反面照片',
                        icon: 'fail'
                    });
                    return;
                }
                if(this.userInfo.picNameT == '' || this.userInfo.picNameT == null){
                    this.$toast({
                        message: '请先上传正面照片',
                        icon: 'fail'
                    });
                    return;
                }

                //提示框
                let formdata = {
                    service: "user.networkPicRealnameInfo",
                    phoneLevel:"5",
                    psptId: this.userInfo.psptId,
                    sex: this.userInfo.sex,
                    custName: this.userInfo.custName,
                    nation: this.userInfo.nation,
                    birthday: this.userInfo.birthday,
                    psptAddr: this.userInfo.psptLocation,
                    penOrg: this.userInfo.penOrg,
                    penStartTime: this.userInfo.penStartTime,
                    penEndTime: this.userInfo.penEndTime,
                    picImageFront: this.picNameZ,
                    picImageBack: this.picNameF,
                    picImageM: this.picNameT,//获取不待http格式的
                    telephone: this.userInfo.contractPhone,
                    phonenum : this.userInfo.phonenum
                }
                this.$dialog.confirm({
                    message: '确认提交实名信息?'
                }).then(() => {
                    this.loadingObj.loadLabel = '正在保存信息中...';
                    this.loadingObj.showLoading = true;
                    this.$api.post("/mstx/pr/gateway.do", formdata, () => {
                        this.loadingObj.showLoading = false;
                        this.nextClick(5);
                    },(res)=>{
                        this.loadingObj.showLoading = false;
                        this.$toast({
                            message: res.errorMsg,
                            icon: 'fail'
                        });
                    });
                });
                
            }
        }
    }
</script>

<style lang="less">

.userInfo{
    margin-top: 47px;
}


.addressInfo{
    margin-top: 10px;
}

.dialog{
    &-button{
        width: 100%;
    }
}
.van-uploader__preview{
    width:320px;
    height:200px;
    position: relative;
}
.picInfo{
    margin-top: 10px;
    margin-bottom: 10px;
    &-cell{
        margin-bottom:30px;
    }
    &-upload{
        text-align: center;
        .van-uploader__preview{
            width: 300px;
            height: 200px;
            margin: 0px 0px;
        }
        .van-uploader__preview-image{
            width: 300px;
            height: 200px;
            text-align: center;
        }
        &-img{
            position: relative;
            width: 300px;
            height: 250px;
        }
    }
}

.contract{
    margin-bottom: 20px;
    margin-top: 20px;
    color: rgb(87, 86, 86);
    text-align: center;
    input{
        margin-right: 10px;
    }
}


.submitInfo{
    width: 90%;
    height: 170px;
    margin-top: 50px !important;
    color: #20A0FF;
    text-align: center;
}

.dataView{
    margin-bottom: 50px;
}
.submitInfo2{
    width: 100%;
    bottom: 0;
    color: #20A0FF;
    text-align: center;
    // position: absolute;
    // margin: 0 ;
    position:fixed;
    display: flex;
}

.van-cell__title{
    text-align: center;
}
.van-cell__label{
    color: red !important;
}
.submitResult{
    width: 100%;
    margin-top: 100px;
     &-img{
        text-align: center;
        margin-top: 10px;
    }
    &-text{
        margin-top: 20px;
        &-red{
            color: red;
            margin-left: 5px;
        }
        &-main{
            margin-top: 20px !important;
            margin-bottom: 5px;
            text-align: center;
            color: rgba(103,224,132,1);
            &-desc{
                margin-top: 10px;
                font-size: 14px;
                color: gray;
            }
        }
    }
}
    
</style>